import React from "react";
import { FaCheck } from "react-icons/fa";

export const Checkbox = ({ label, checked, key, htmlFor }) => (
    <label
        key={key}
        htmlFor={htmlFor}
        className={`${
            checked
            ? `bg-black text-white font-medium`
            : "bg-gray-100 text-black"
        } text-right text-base sm:text-lg leading-5 sm:leading-6 font-normal rounded-full pr-2 pl-7 py-2.5 cursor-pointer flex items-center justify-end my-3 lg:my-4`}
    >
        {label}
        <span className={`flex flex-0-0-auto justify-center items-center w-4 h-4 text-white border border-gray-400 rounded mx-2.5`}>
            {checked && <FaCheck size={8} />}
        </span>
    </label> 
)
